import { RankingComponent } from './ranking/ranking.component'
import { NgModule } from '@angular/core'
import { RouterModule, UrlSegment } from '@angular/router'
import { RankingResolver } from './ranking/ranking.resolver'
import { MetaGuard } from 'meta'
import { RedirectGuard } from '../libs/common/redirect.guard'
import { RankingsComponent } from './rankings/rankings.component'
import { RankingsGuard } from '../shared/guards/rankings.guard'
import { RANKINGS_LIST } from './rankings-analytics.service'
import { SegmentTagMap } from '../shared/analytics/models/segment-tag-map.model'
import { pathMatcher } from '../shared/utility-functions/slug.utility'
import { CORE_ID_RULES } from '../shared/utility-functions/regex.utility'
import { SpecialRankingsComponent } from './special-rankings/special-rankings.component'

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: RankingsComponent,
        canActivate: [MetaGuard, RankingsGuard],
        data: {
          /**
           * This will both prevent automatic page calls and also allow the
           * analytics directive to work.
           *
           * @see outExcludedRoutes
           */
          segment: RANKINGS_LIST,
          shouldShowEventTicker: true,
          meta: {
            'og:type': 'meta_ranking_page_type'
          },
          noTopScroll: true
        },
        children: [
          {
            path: 'search',
            component: RankingsComponent
          }
        ]
      },
      {
        matcher: url => {
          try {
            const level = url[0].path
            if (['college', 'high-school'].includes(level)) {
              const gender = url[1]?.path
              return {
                consumed: url,
                posParams: { level: new UrlSegment(level, {}), gender: new UrlSegment(gender, {}) }
              }
            }
          } catch (e) {}
          return null
        },
        component: SpecialRankingsComponent
      },
      {
        path: ':slug',
        resolve: { node: RankingResolver },
        canActivate: [MetaGuard, RedirectGuard],
        data: {
          redirect: {
            testRegExp: /\/rankings\/6811625/,
            newUrl: 'https://leaderboard.varsity.com'
          },
          segment: SegmentTagMap.RANKINGS_DETAIL,
          shouldShowAdSkin: false,
          shouldShowEventTicker: true,
          meta: {
            'og:type': 'meta_ranking_page_type'
          }
        },
        children: [
          {
            matcher: url => pathMatcher(url, 'rankingSlug', CORE_ID_RULES),
            component: RankingComponent,
            data: {
              noTopScroll: true
            }
          }
        ]
      }
    ])
  ],
  exports: [RouterModule],
  providers: [RankingsGuard]
})
export class RankingsRoutingModule {}
